import React from 'react';
import PersonCard from '../components/PersonCard';
import peopleData from '../people.json';
import './PatientPartners.css';

function PatientPartners() {
  const { patientPartners } = peopleData;

  return (
    <div className="page patient-partners-page">
      <div className="container">
        <header className="page-header">
          <h1>{patientPartners.section}</h1>
          <div className="accent-bar"></div>
        </header>
        <div className="patient-partners-list">
          {patientPartners.members.map((partner) => (
            <PersonCard
              key={partner.name}
              name={partner.name}
              role={partner.role}
              image={partner.image}
              imagePosition={partner.imagePosition}
              bio={partner.bio}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default PatientPartners;